import { Navigate } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";

export default function RoleRoute({ allowedRoles, children }) {
  const { user } = useAuth();
  return allowedRoles.includes(user?.role) ? children : <Navigate replace to="/" />;
}
